import axios from "@/request";
import qs from "qs";

export default {
  /* 纠错详情 */
  async info(params: any) {
    return axios.get("invest-correct/info", { params });
  },
  /* 保存纠错信息 */
  async save(params: any) {
    return axios.post("invest-correct/save", qs.stringify(params));
  },
  /* 保存纠错片场信息 */
  async save_ground(params: any) {
    return axios.post("invest-correct/save-ground", qs.stringify(params));
  },
  /* 添加片场价格 */
  async add_price(params: any) {
    return axios.post("invest-correct/add-price", qs.stringify(params));
  },
  /* 提交纠错审核 */
  async submit(params: any) {
    return axios.post("invest-correct/submit", qs.stringify(params));
  },
}
